import React, { useEffect, useState } from 'react';
import img1 from '../../Image/AdminPro.svg';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
    const [loader, setLoader] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const navigate = useNavigate()
    const [user, setUser] = useState({
        a_email: "",
        a_name: "",
        a_state: "",
        a_city: "",
        a_address: "",
        a_phone: "",
    });

    const handleInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value })
    }

    const handleEditClick = async () => {
        if (isEditing) {
            setIsEditing(!isEditing);
            setLoader(true)
            try {
                const body = {
                    a_name: user?.a_name,
                    a_state: user?.a_state,
                    a_city: user?.a_city,
                    a_phone: user?.a_phone,
                    a_address: user?.a_address
                }
                const resp = await Calling.AdminProfileUpdate(body);
                const { status, data, message } = resp;
                if (status) {
                    setUser(data);
                    toast.success(message);
                } else {
                    toast.error(message);
                }
            } catch (error) {
                navigate('/Error');
            } finally {
                setLoader(false)
            }
        } else { setIsEditing(!isEditing); }

    };

    useEffect(() => {
        const fetchData = async () => {
            setLoader(true)
            try {
                const resp = await Calling.GetAdminData();
                const { status, data, message } = resp;
                if (status) {
                    setUser(data);
                } else {
                    toast.error(message);
                }
            } catch (error) {
                navigate('/Error');
            } finally {
                setLoader(false)
            }
        }
        fetchData()
        // eslint-disable-next-line
    }, [])

    return (<>
        {loader ? <Loader loader={loader} /> :
            <div className="w-full text-black min-h-screen p-4 md:p-8" >
                <div className='w-full flex flex-col md:flex-row min-h-screen mt-[30px] md:mt-[50px] gap-6'>
                    {/* Profile Picture Section */}
                    <div className='w-full md:basis-[40%] flex justify-center'>
                        <div className='bg-main-white w-full md:w-[60%] p-6 rounded-lg h-[300px] shadow-lg'>
                            <div className='flex flex-col items-center space-y-4'>
                                <img src={img1} alt="Profile" className='w-28 md:w-36 transition-transform hover:scale-105' />
                                <hr className='border-gray-200 w-[80%]' />
                                <div className='text-xl md:text-2xl font-semibold text-main-font'>{user?.a_name}</div>
                            </div>
                        </div>
                    </div>

                    {/* Admin Details Section */}
                    <div className='w-full md:basis-[60%]'>
                        <div className='bg-main-white w-full md:w-[90%] rounded-lg shadow-lg p-6 md:p-8'>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                <div className='mt-3'>
                                    <label className='text-lg'>Email:</label>
                                    <input
                                        type="text"
                                        value={user?.a_email}
                                        name='a_email'
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        disabled
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='mt-3'>
                                    <label className='text-lg'>Name:</label>
                                    <input
                                        type="text"
                                        value={user?.a_name}
                                        name='a_name'
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='mt-3'>
                                    <label className='text-lg'>State:</label>
                                    <input
                                        type="text"
                                        name='a_state'
                                        value={user?.a_state}
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='mt-3'>
                                    <label className='text-lg'>City:</label>
                                    <input
                                        type="text"
                                        name='a_city'
                                        value={user?.a_city}
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='mt-3'>
                                    <label className='text-lg'>Phone:</label>
                                    <input
                                        type="text"
                                        name="a_phone"
                                        value={user?.a_phone}
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        readOnly={!isEditing}
                                        maxLength='11'
                                        minLength='9'
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-span-2 mt-3'>
                                    <label className='text-lg'>Address:</label>
                                    <input
                                        type="text"
                                        name='a_address'
                                        value={user?.a_address}
                                        className={`w-full border-b-2 border-main-border outline-none text-lg transition-all duration-300 focus:border-primary-blue
                                        ${isEditing ? 'border-primary-blue bg-purple-50 focus:bg-purple-100' : ''} my-2 px-2 py-1`}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className='mt-8 flex justify-end gap-3'>
                                <button
                                    onClick={handleEditClick}
                                    className={`py-2 px-6 rounded-lg text-main-white transition-colors duration-300
                                    ${isEditing
                                            ? 'bg-primary-purple hover:bg-primary-purple-dark'
                                            : 'bg-primary-blue hover:bg-primary-dark'
                                        } focus:ring-2 focus:ring-offset-2 focus:ring-main-subfont  focus:outline-none`}
                                >
                                    {isEditing ? 'Save' : 'Edit'}
                                </button>
                                {isEditing &&
                                    <button
                                        onClick={() => setIsEditing(false)}
                                        className="py-2 px-6 rounded-lg text-main-white bg-red-500 hover:bg-red-600 
                                        transition-colors duration-300 focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                    >
                                        Cancel
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </>);
}

export default Profile;
